/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  GagarinVesting,
  GagarinVestingInterface,
} from "../GagarinVesting";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "AddReceivers",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "ChangeReceivers",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Release",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "RemoveReceivers",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint128[]",
        name: "dates",
        type: "uint128[]",
      },
      {
        indexed: false,
        internalType: "uint128[]",
        name: "percent",
        type: "uint128[]",
      },
    ],
    name: "SetVestingSchedule",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "PERCENT_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token_",
        type: "address",
      },
    ],
    name: "__GagarinVesting_init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "addReceivers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "changeReceivers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "copyReceiverData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128[]",
        name: "percent",
        type: "uint128[]",
      },
    ],
    name: "isValidVestingPercent",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "payedStakingReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "vestingScheduleIds",
        type: "uint256[]",
      },
    ],
    name: "receiverInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "released",
            type: "uint256",
          },
          {
            internalType: "uint16",
            name: "claimed",
            type: "uint16",
          },
        ],
        internalType: "struct GagarinVesting.ReceiverInfo[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "receiverInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "released",
            type: "uint256",
          },
          {
            internalType: "uint16",
            name: "claimed",
            type: "uint16",
          },
        ],
        internalType: "struct GagarinVesting.ReceiverInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "vestingScheduleIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "releasable",
    outputs: [
      {
        internalType: "uint256[3][]",
        name: "",
        type: "uint256[3][]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "releasable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "removeReceivers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token_",
        type: "address",
      },
    ],
    name: "setVestedToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
      {
        internalType: "uint128[]",
        name: "dates",
        type: "uint128[]",
      },
      {
        internalType: "uint128[]",
        name: "percent",
        type: "uint128[]",
      },
      {
        internalType: "bool",
        name: "withStaking",
        type: "bool",
      },
    ],
    name: "setVestingSchedule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128[]",
        name: "dates",
        type: "uint128[]",
      },
      {
        internalType: "uint128[]",
        name: "percent",
        type: "uint128[]",
      },
      {
        internalType: "bool",
        name: "withStaking",
        type: "bool",
      },
    ],
    name: "setVestingSchedule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalVestingSchedules",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "vestingSchedule",
    outputs: [
      {
        components: [
          {
            internalType: "uint128[]",
            name: "dates",
            type: "uint128[]",
          },
          {
            internalType: "uint128[]",
            name: "percent",
            type: "uint128[]",
          },
          {
            internalType: "uint256",
            name: "vestedAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "released",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "withStaking",
            type: "bool",
          },
        ],
        internalType: "struct GagarinVesting.VestingSchedule",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type GagarinVestingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GagarinVestingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GagarinVesting__factory extends ContractFactory {
  constructor(...args: GagarinVestingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<GagarinVesting> {
    return super.deploy(overrides || {}) as Promise<GagarinVesting>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GagarinVesting {
    return super.attach(address) as GagarinVesting;
  }
  override connect(signer: Signer): GagarinVesting__factory {
    return super.connect(signer) as GagarinVesting__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GagarinVestingInterface {
    return new utils.Interface(_abi) as GagarinVestingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GagarinVesting {
    return new Contract(address, _abi, signerOrProvider) as GagarinVesting;
  }
}
